export default {
    data () {
        return {
            shareLinks: {
                fb: '',
                tw: '',
                wa: '',
                li: ''
            }
        }
    },

    mounted () {
        this.setupShareLinks()
    },

    activated () {
        this.setupShareLinks()
    },

    methods: {
        setupShareLinks () {
            let url = 'https://www.velbert-zeigt-herz.de/'
            let text = 'Velbert zeigt Herz - Die Stadtwerke Velbert spenden für lokale Projekte und Sie entscheiden mit!'

            if (this.$route.params.id) {
                url = url + 'projekte/' + this.$route.params.id
                text = 'Ein gemeinnütziges Projekt braucht Eure Unterstützung! „Velbert zeigt Herz“ ist eine Aktion, bei der Ihr entscheiden könnt, welches Projekt eine Spende von den Stadtwerken Velbert bekommt. Ich möchte Euch dieses Projekt ans Herz legen: ' + url
            }

            this.shareLinks = {
                fb: 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
                tw: 'https://twitter.com/home?status=' + encodeURIComponent(text),
                wa: 'https://wa.me/?text=' + encodeURIComponent(text),
                li: 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(url)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/ShareLinks.js